module.exports = __webpack_public_path__ + "img/home-icon-selected.2b01a694.svg";